import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonModule as NimbusCommonModule } from '../common/common.module';
import { EmbedHeaderComponent } from './embed-header.component';
import { EmbedPopupComponent } from './embed-popup.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    NimbusCommonModule,
    FormsModule,
  ],
  exports: [
    EmbedHeaderComponent,
    EmbedPopupComponent,
  ],
  declarations: [
    EmbedHeaderComponent,
    EmbedPopupComponent,
  ],
  entryComponents: [
    EmbedPopupComponent,
  ],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmbedModule { }

